export const searchEntriesActionTypes = {
    'PAGE_INIT': 'SEARCH_ENTRIES_PAGE_INIT',
    'PAGE_NEXT': 'SEARCH_ENTRIES_PAGE_NEXT',
    'PAGE_PREVIOUS': 'SEARCH_ENTRIES_PAGE_PREVIOUS',
    'PAGE_REQUEST': 'SEARCH_ENTRIES_PAGE_REQUEST',
    'PAGE_SUCCESS': 'SEARCH_ENTRIES_PAGE_SUCCESS',
    'PAGE_ERROR': 'SEARCH_ENTRIES_PAGE_ERROR',
    'TOGGLE_SELECTION': 'SEARCH_ENTRIES_TOGGLE_SELECTION',
    'CLEAR_SELECTION': 'SEARCH_ENTRIES_CLEAR_SELECTION',
    'TOGGLE_ALL': 'SEARCH_ENTRIES_TOGGLE_ALL',
    'ADD_FILTER': 'SEARCH_ENTRIES_ADD_FILTER',
    'REMOVE_FILTER': 'SEARCH_ENTRIES_REMOVE_FILTER',
};